export default __webpack_public_path__ + "onboardingAlertPreferences.61696226.png";